<template>
  <div class="scan">
    <div class="scan-banner">
      <div class="banner">
        <div class="banner-left">
          <div class="banner-blue">
            蓝凌新一代
            <span>·</span>蓝凌智能OA
          </div>
          <div class="banner-left-content">
            <p class="blt-quote">
              <img src="../assets/scancode/quotetop.png" alt />
            </p>
            <div class="bl-tips">
              <span>一次 安装，</span>
              <span>电脑、手机多平台通用；</span>
            </div>
            <div class="bl-tips">
              <span>数据云端同步，</span>
              <span>CRM、办公OA 一站解决。</span>
            </div>
            <p class="blr-quote">
              <img src="../assets/scancode/quotebottom.png" alt />
            </p>
            <div class="bl-piece">
              <img src="../assets/scancode/piece.png" alt />
            </div>
          </div>
        </div>
        <div class="banner-right">
          <p class="header">扫码立即体验</p>
          <p class="scan-tips">钉钉扫码 加入智能OA体验组织</p>
          <div class="scan-code">
            <img src="../assets/scancode/saocode.png" alt />
          </div>
          <p class="scan-tips-btn">每天限10个体验名额</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.scan {
  .scan-banner {
    margin-top: 70px;
    background:url('../assets/banner-help.png') 0 0 no-repeat;
    background-size:100% 780px;
    color:white;
    .banner {
      width: 1200px;
      margin: 0 auto;
      height: 780px;
      padding-top: 116px;
      padding-left: 80px;
      padding-right:30px;
      display: flex;
      justify-content: space-between;
      .banner-left {
        width: 500px;
        padding-top:0;
        .banner-blue {
          font-size: 24px;
          color:white;
          span {
            margin: 0 10px;
          }
        }
        .banner-left-content {
          .blt-quote {
            text-align: left;
            margin-top: 20px;
            width: 45px;
            height: 45px;
            img {
              width: 100%;
            }
          }
          .bl-tips {
            font-size: 20px;
            margin-bottom: 22px;
            padding-left: 67px;
            span {
              display: block;
              line-height: 40px;
            }
          }
          .blr-quote {
            text-align: right;
            padding-right: 117px;
            img {
              width: 45px;
            }
          }
          .bl-piece {
            height: 200px;
            img {
              height: 200px;
            }
          }
        }
      }
      .banner-right {
        text-align: center;
        width: 420px;
        height: 520px;
        box-shadow: 0 -2px 20px 0 rgba(23,102,246,0.50);
        border-radius: 10px;
        background:white;
        display: inline-block;
        // margin-left:217px;
        .header {
          border-radius: 10px 10px 0 0;
          height: 74px;
          font-size: 20px;
          color: #ffffff;
          line-height: 74px;
          background: #00A7FF;
        }
        .scan-tips {
          padding-top: 50px;
          padding-bottom: 24px;
          font-size: 14px;
          color: #999999;
        }
        .scan-tips-btn{
            font-size: 14px;
            color: #4285F4;
            text-align: center;
            padding:30px 0;
        }
        .scan-descwrap{
            width:320px;
            margin:0 auto;
            border-top:1px solid  #F2F2F2;
            padding-top:25px;
        }
        .scan-desc{
            font-size: 14px;
color: #999999;
text-align: center;
line-height: 20px;
        }
        .scan-code {
          position: relative;
          width: 214px;
          height: 220px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
          img {
            width: 170px;
            height: 170px;
          }
          .image-border {
            position: absolute;
            width: 20px;
            height: 20px;
          }

          .image-border1 {
            top: 0;
            left: 0;
            border-left: 5px solid #000000;
            border-top: 5px solid #000000;
          }

          .image-border2 {
            top: 0;
            right: -2px;
            border-right: 5px solid#000000;
            border-top: 5px solid#000000;
          }

          .image-border3 {
            bottom: 0;
            left: 0;
            border-bottom: 5px solid#000000;
            border-left: 5px solid#000000;
          }

          .image-border4 {
            bottom: 0;
            right: -2px;
            border-right: 5px solid#000000;
            border-bottom: 5px solid#000000;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/scanCode.vue